// composables/useSlack.js
import {apiClient} from "@/services/auth-header";

export function useSlack() {
  const sendErrorMessage = async (message) => {
    if (!message?.trim()) {
      return;
    }
    try {
      await apiClient.post('/v1/slack/send-error', { message });
    } catch (error) {
      console.error('Slack 메시지 전송 실패:', error);
    }
  };

  return { sendErrorMessage };
}